// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template7_reactPlayer__kjz4U","heading":"Template7_heading__4xDEq","description":"Template7_description__iRdw-"};